module.exports = __webpack_public_path__ + "img/head-icon.a52e2ba0.png";